<router-outlet />
<qaroni-msal-redirect />
